import { VuexModule, Module, action, mutation } from 'vuex-class-component';
import axios from 'axios';
import { PostListResponse } from './postListResponse';
import { Post } from './post';
import { vxm } from '@/store.vuex';
@Module({ namespacedPath: 'forum/' })
export class ForumStore extends VuexModule {
  private postListResponse = new PostListResponse();
  private postList: Array<Post> = [];
  private pageNumber: number = 1;
  private pageSize = 5;
  private busy: boolean = false;
  private commentPageNumber = 1;
  private showLoadMoreComments = false;
  private commentList: Array<any> = [];
  private likeUserList = '';
  private postDetails = new Post();
  private reportReasons: Array<any> = [];
  private categories: Array<any> = [];

  public get ReportReasons() {
    return this.reportReasons;
  }
  public get PostDetails() {
    return this.postDetails;
  }
  public get PostList() {
    return this.postList;
  }
  public get PostListResponse() {
    return this.postListResponse;
  }
  public get Busy() {
    return this.busy;
  }

  public get CommentList() {
    return this.commentList;
  }

  public get ShowLoadMoreComments() {
    return this.showLoadMoreComments;
  }

  public get LikeUserList() {
    return this.likeUserList;
  }

  public get Categories() {
    return this.categories;
  }

  @mutation
  public setReportReasons(data) {
    this.reportReasons = data;
  }

  @mutation
  public setBusy(val: boolean) {
    this.busy = val;
  }

  @mutation
  public setPostListResponse(response: PostListResponse) {
    this.postListResponse = response;
  }

  @mutation
  public resetPostList(postList: Array<Post>) {
    this.postList = postList;
  }

  @mutation
  public setPostList(postList: Array<Post>) {
    this.postList = [...this.postList, ...postList];
  }

  @mutation
  public setPageNumber(pageNumber: number) {
    this.pageNumber = pageNumber;
  }

  @mutation
  public setCommentList(list: Array<any> = []) {
    this.commentList = [...this.commentList, ...list];
  }

  @mutation
  public resetCommentList(commentList) {
    this.commentList = commentList;
  }

  @mutation
  public setCommentPageNumber(number) {
    this.commentPageNumber = number;
  }

  @mutation
  public setLoadMoreComments(val) {
    this.showLoadMoreComments = val;
  }

  @mutation
  public setLikeUserList(val) {
    this.likeUserList = val;
  }

  @mutation
  public setPostDetails(details: Post) {
    this.postDetails = details;
  }

  @mutation
  public setCategories(payload) {
    this.categories = payload || [];
  }

  @action({ mode: 'mutate' })
  public async likePost(postId) {
    const response = await axios.post(
      '/forum/api/votes',
      {
        postId,
        // userId: vxm.users.myUserProfile.userId,
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
    if (response.data.status === 1) {
      this.resetPostList(
        this.postList.map((post) => {
          if (post.postId === postId) {
            post.hasLiked = !post.hasLiked;
            post.upCount++;
          }
          return post;
        }),
      );
    } else if (response.data.status === 3) {
      this.resetPostList(
        this.postList.map((post) => {
          if (post.postId === postId) {
            post.hasLiked = false;
            post.upCount--;
          }
          return post;
        }),
      );
    }
  }

  @action({ mode: 'mutate' })
  public async loadPosts({
    initCall = false,
    searchVal = '',
    allCategories = -1,
  } = {}) {
    this.setBusy(true);
    if (
      !initCall &&
      this.pageNumber * this.pageSize >= this.PostListResponse.resultSize
    ) {
      return Promise.reject();
    }
    if (initCall) {
      this.resetPostList([]);
      this.setPageNumber(1);
    } else {
      this.setPageNumber(this.pageNumber + 1);
    }
    const response = await axios.post(
      '/forum/api/v1/posts/list',
      {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        companyCode: vxm.jobs.BrandingInfo.companycode,
        filterSearchValues: {
          customFilter: {
            allPosts: -1,
            allStatus: -1,
            allCategories: String(allCategories),
          },
          standardFilter: { searchByPost: searchVal },
        },
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
          'app-agent': 'CANDIDATE-PORTAL',
        },
      },
    );
    this.setBusy(false);
    this.setPostListResponse(response.data);
    this.setPostList(response.data.forumPostResponses || []);
    return;
  }
  @action({ mode: 'mutate' })
  public async listComments({ postId, initCall }) {
    initCall && this.resetCommentList([]);
    const response = await axios.post(
      '/forum/api/v1/comments/list',
      {
        commentVO: { postId },
        pageNumber: initCall ? 1 : this.commentPageNumber,
        pageSize: 10,
        // userId: vxm.users.myUserProfile.userId,
        orderby: { optionSelected: 1, isAsc: false },
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
          'app-agent': 'CANDIDATE-PORTAL',
        },
      },
    );
    this.setCommentList(response.data.forumCommentList || []);
    this.resetPostList(
      this.postList.map((post) => {
        if (post.postId === postId) {
          post.unreportedCommentCount = response.data.resultSize;
        }
        return post;
      }),
    );
    const { pageSize, pageNumber, resultSize } = response.data;
    this.setLoadMoreComments(resultSize > pageNumber * pageSize);
    this.setCommentPageNumber(pageNumber + 1);
  }
  @action({ mode: 'mutate' })
  public async postComment({ postId, commentText }) {
    await axios.post(
      '/forum/api/v1/comments',
      {
        commentVO: { postId, commentText },
        // userId: vxm.users.myUserProfile.userId,
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async createPost(forumObject) {
    const resp = await axios.post(
      '/forum/api/v1/posts/createpost',
      {
        action: forumObject.action,
        body: forumObject.forumPost,
        companyCode: forumObject.companyCode,
        postImage: '',
        title: forumObject.title,
        categoryId: forumObject.categoryId,
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
    return resp.data;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async editPost(forumObject) {
    const resp = await axios.post(
      '/forum/api/v1/posts/createpost',
      {
        action: forumObject.action,
        body: forumObject.forumPost,
        companyCode: forumObject.companyCode,
        postImage: '',
        title: forumObject.title,
        categoryId: forumObject.categoryId,
        postId: forumObject.postId,
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
    return resp.data;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async uploadImage(file) {
    const resp = await axios.post('/forum/api/v1/posts/uploadimage', {
      file: 'file',
    });
    return resp.data;
  }

  /////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async deletePost(post) {
    const response = await axios.post(
      '/forum/api/v1/posts/update',
      {
        postDetail: post,
        // userId: vxm.users.myUserProfile.userId,
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
    const index = this.postList.findIndex((p) => p.postId == post.postId);
    this.postList.splice(index, 1);
    this.resetPostList(this.postList);

    return response.data;
  }

  @action({ mode: 'mutate' })
  public async fetchLikeList(postId) {
    this.setLikeUserList([]);
    const response = await axios.post(
      '/forum/api/votes/userlist',
      {
        filterSearchValues: { standardFilter: null, customFilter: null },
        pageNumber: 1,
        pageSize: 500,
        postId,
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
    this.setLikeUserList(response.data.forumUserVOs);
  }

  //////////////////////////////////////////////////
  @action()
  public async getPost(postId: Number) {
    for (let post of this.postList) {
      if (post.postId == postId) return post;
    }
    return this.postList;
  }

  @action({ mode: 'mutate' })
  public async reportPost({
    reportedEntityId,
    forumReportReasonCodeId,
    reportedReasonDescription,
    reportedEntityType,
  }) {
    const response = await axios.post(
      '/forum/api/v1/reported',
      {
        reportedEntityId,
        reportedEntityType,
        forumReportReasonCodeId,
        reportedReasonDescription,
        // userId: vxm.users.myUserProfile.userId,
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
    return response;
  }

  @action({ mode: 'mutate' })
  public async deleteComment({ commentId, postId }) {
    await axios.delete('/forum/api/v1/comments/' + commentId, {
      headers: {
        Authorization: `Bearer ${vxm.users.getToken}`,
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
  }
  @action({ mode: 'mutate' })
  public async fetchPostDetails(postId) {
    const response = await axios.get(`/forum/api/v1/posts/${postId}`, {
      headers: {
        Authorization: `Bearer ${vxm.users.getToken}`,
      },
    });
    this.resetPostList([response.data.forumPostResponse]);
  }

  @action({ mode: 'mutate' })
  public async updateComment(params) {
    const response = await axios.post(
      '/forum/api/v1/comments/update',
      {
        commentVO: params,
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );

    this.resetCommentList(
      this.commentList.map((comment) => {
        if (comment.commentId === params.commentId) {
          return {
            ...comment,
            commentText: response.data.commentVO.commentText,
            updatedDTTM: response.data.commentVO.updatedDTTM,
          };
        }
        return comment;
      }),
    );
  }

  @action({ mode: 'mutate' })
  async fetchReportReasons() {
    const response = await axios.get('/forum/api/v1/reported/reasons');
    this.setReportReasons(response.data.forumReportReasonList);
  }

  @action({ mode: 'mutate' })
  async fetchCategories() {
    const response = await axios.post(
      '/forum/api/v1/category/search',
      {
        pageSize: 50,
        pageNumber: 1,
        filter: {
          status: 'active',
          keyword: '',
        },
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
    this.setCategories(response.data.data.content);
  }
}
